export default "__VITE_ASSET__b2622ac6__"